import React, { FC, ReactElement } from 'react'
import PasswordTextInput, { Props } from '../../../../React/Common/Components/PasswordTextInput/PasswordTextInput'

export const OutlinedPasswordTextInput: FC<Props> = (props: Props): ReactElement => (
    <PasswordTextInput {...props} className='outlined-password-text-input' variant='outlined' />
)
